"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metrics = exports.MetricKey = void 0;
var _analyticsState = require("./analytics-state");
var _cohort = require("./cohort");
var _gasv = require("./gasv3");
var _tracking = require("./tracking");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Module for segment metrics tracking events.
 * @module Metrics
 */
var MetricKey = exports.MetricKey = /*#__PURE__*/function (MetricKey) {
  MetricKey["TIME_TO_LOAD"] = "timeToLoad";
  MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
  MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
  MetricKey["TIME_TO_READY"] = "timeToReady";
  MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
  MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
  MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
  return MetricKey;
}({});
var Metrics = exports.Metrics = /*#__PURE__*/function () {
  function Metrics() {
    _classCallCheck(this, Metrics);
  }
  return _createClass(Metrics, null, [{
    key: "logMetric",
    value:
    /**
     * Store the value of a single performance metric
     * @function logMetrics
     * @param {MetricKey} metricKey - the metric to log
     * @param {number} mockDate - a mock timestamp
     */
    function logMetric(metricKey, mockDate) {
      Metrics.metricsData[metricKey] = mockDate || Date.now();
    }
  }, {
    key: "setLoadTimestamp",
    value: function setLoadTimestamp(loadTimestamp) {
      Metrics.loadTimestamp = loadTimestamp;
    }

    /**
     * Logs a performance metrics track call to segment via the HTTP API
     * @function sendMetrics
     * @param {object} mockReq used in testing so we don't actually send anything to Segment
     */
  }, {
    key: "sendMetrics",
    value: function sendMetrics(mockReq) {
      var loadTimestamp = Metrics.loadTimestamp;
      if (!loadTimestamp) {
        return;
      }

      // calculate all of the times
      Object.entries(Metrics.metricsData).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (value > 0) {
          // Todo .. should this be > loadTimestamp ??
          Metrics.metricsData[key] = value - loadTimestamp;
        }
      });
      var cohort = _cohort.Cohort.readAtlCohort();
      var properties = {
        action: 'metrics',
        actionSubject: 'atlGlobal',
        metrics: Metrics.metricsData,
        atlJSVersion: _analyticsState.AnalyticsState.version,
        cohort: cohort ? cohort.bucketAll.index : null,
        host: mockReq ? mockReq.hostFake : window.location.host,
        path: mockReq ? mockReq.pathFake : window.location.pathname,
        pageViewId: _tracking.Tracking.getPageViewId() // used to tie to other events
      };
      _gasv.GASv3.sendUIEvent('', properties, true);
      Metrics.resetMetrics();
    }

    // testing only
  }, {
    key: "resetMetrics",
    value: function resetMetrics() {
      Metrics.metricsData = {};
    }
  }]);
}();
_defineProperty(Metrics, "metricsData", {});